import axios, { axiosNT } from '../../../services/axios';
import { UserGroupsBody } from '../types/UserGroupsBody';

const create = (postData: UserGroupsBody) => {
	return axios.post('/userGroups/', postData)
		.then((res: any) => {
			let userGroups: UserGroupsBody[] = res.responseObject;
			return Promise.resolve(userGroups);
		});
}

const update = (postData: UserGroupsBody, id: string) => {
	return axios.put(`/userGroups/${id}`, postData)
		.then((res: any) => {
			let userGroups: UserGroupsBody[] = res.responseObject;
			return Promise.resolve(userGroups);
		});
}

const remove = (name: string, id: string) => {
	return axios.delete(`/userGroups/${id}/${name}`)
		.then((res: any) => {
			let userGroups: UserGroupsBody[] = res.responseObject;
			return Promise.resolve(userGroups);
		});
}

const list = () => {
	return axiosNT.get('/userGroups/')
		.then((res: any) => {
			let userGroups: UserGroupsBody[] = res.responseObject;
			return Promise.resolve(userGroups);
		});
}

const count = () => {
	return axiosNT.get('/userGroups/count')
		.then((res: any) => {
			const { count } = res.responseObject;
			return Promise.resolve(count);
		});
}

const assignRole = (formData: any) => {
	return axios.post('/userGroups/assignRole', formData)
		.then((res: any) => {
			const statusCode = res.statusCode;
			return Promise.resolve(statusCode);
		})
}

const removeRole = (groupId: string, roleId: string, miniLibraryId: string) => {
	return axios.delete(`/userGroups/removeRole/${groupId}/${roleId}/${miniLibraryId}`)
		.then((res: any) => {
			const statusCode = res.statusCode;
			return Promise.resolve(statusCode);
		})
}

export default {
	create,
	update,
	remove,
	list,
	count,
	assignRole,
	removeRole
};